export default {
  "select-a-language": "select a language".toUpperCase(),
  select: "select".toUpperCase(),
  language: "english".toUpperCase(),
};
